import React, { Component } from 'react';
import { UserApprovalFilter } from './UserApprovalFilter.jsx';
import { UserApprovalsTable } from './UserApprovalsTable.jsx';

export class Home extends Component {
    constructor(props) {
        super(props);
        this.state = { filterStatus: "Submitted" };

        this.onStatusChange = this.onStatusChange.bind(this);
    }

    onStatusChange(status) {
        this.setState({ filterStatus: status });
    }

    render() {
        return (
            <div>
                <section className="grid-container noPaddingX page-header">
                    <h1 className="section-header">User Registrations</h1>
                </section>

                <section className="grid-container noPaddingX">
                    <div className="grid-x">
                        <div className="large-12 cell">
                            <UserApprovalFilter onStatusChange={this.onStatusChange} />
                            <UserApprovalsTable filterStatus={this.state.filterStatus} />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}